import { apiRequest, invalidateCache } from './api.js';

export function createSubscriptionsService(helium) {
	const subscriptionsChannel = helium.factory('subscriptions:list', { data: [], loading: false });
	
	const getAll = async (filters = {}, signal) => {
		return await apiRequest('/api/v1/admin/subscriptions', { params: filters, signal }, true);
	};
	
	const updateFeatures = async (subscriptionId, featureFlags, signal) => {
		invalidateCache('/api/v1/admin/subscriptions');
		return await apiRequest(`/api/v1/admin/subscriptions/${subscriptionId}`, {
			method: 'PATCH',
			body: JSON.stringify({ featureFlags }),
			signal
		});
	};
	
	return { subscriptionsChannel, getAll, updateFeatures };
}
